var $79a999abfc605712$exports = {};
$79a999abfc605712$exports = {
    "Clear search": `Po\u{10D}isti iskanje`
};


export {$79a999abfc605712$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
